import {
    displaysOwnerActions,
    displaysOwnerThunks as defaultThunks,
    displaysOwnerSelectors as defaultSelectors,
    displaysOwnerReducer,
} from './DisplaysOwner-slice';
import * as thunks from './DisplaysOwner-thunks';
import * as selectors from './DisplaysOwner-selectors';

const displaysOwnerThunks = { ...defaultThunks, ...thunks };
const displaysOwnerSelectors = { ...defaultSelectors, ...selectors };

export { displaysOwnerSelectors, displaysOwnerActions, displaysOwnerThunks, displaysOwnerReducer };
